import React, { FC, useMemo } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useSignUp } from './hooks/useSignUp';
import { getPasswordValidationSchema } from '@/ui-kit/utils/getPasswordValiadtionSchema';
import { SignUpPageFormInner } from './components/FormInner';
import { SignUpRequest } from '../../../../transport/types/SignUpRequest';
import { useSearchParams } from 'react-router-dom';
import { useParamUserType } from './hooks/useParamUserType';

export const SignUpPageForm: FC = () => {
    const { t: validationT } = useTranslation('bo-kit__validation');
    const { isLoading, doSignUp, isUserExistError, clearState, isError, errorMessage } =
        useSignUp();
    const [searchParams] = useSearchParams();
    const referralCode = searchParams.get('referral_code') ?? undefined;

    const validationSchema = useMemo(
        () =>
            Yup.object().shape({
                username: Yup.string()
                    .email('Invalid email format')
                    .required(validationT('Field is required')),
                password: getPasswordValidationSchema(validationT),
                confirmPassword: Yup.string()
                    .oneOf([Yup.ref('password'), ''], validationT('Passwords must match'))
                    .required(validationT('Field is required')),
                termsAndCondition: Yup.boolean().oneOf([true], validationT('Accept terms')),
            }),
        [validationT]
    );

    const { userType } = useParamUserType();

    return (
        <Formik<SignUpRequest>
            initialValues={{
                username: searchParams.get('email') || '',
                password: '',
                confirmPassword: '',
                termsAndCondition: false,
                userType: userType,
                ...(referralCode && { referralCode: referralCode }),
            }}
            onSubmit={doSignUp}
            validationSchema={validationSchema}
        >
            {(formik) => (
                <SignUpPageFormInner
                    formik={formik}
                    isLoading={isLoading}
                    isUserExistError={isUserExistError}
                    clearState={clearState}
                    isError={isError}
                    errorMessage={errorMessage}
                />
            )}
        </Formik>
    );
};
